export default function Template(props) {
    const {content, page} = props

    return <div>
        <div>Сторінка <i>{content.city}:{content.did}</i> не існує</div>
    </div>
}
